import { Outlet } from 'react-router-dom';
import Header from './Header';
import { useDashboard } from '../../hooks/useDashboard';
import { useShop } from '../../hooks/useShop';

export default function Shell() {
  const { currentShopId } = useShop();
  const { data, loading, lastRefresh, refresh } = useDashboard(currentShopId);

  let totalIssues = 0;
  let totalDollarsRaw = 0;

  if (data) {
    const moduleKeys = [
      'credits', 'missing_invoices', 'cost_discrepancies',
      'unreturned_cores', 'ordered_never_received', 'invalid_ro_refs',
    ];

    moduleKeys.forEach((key) => {
      const mod = data[key];
      if (mod) {
        const count = mod.count ?? mod.items?.length ?? 0;
        totalIssues += count;
        totalDollarsRaw += mod.total_exposure_usd ?? mod.total_outstanding_usd ?? mod.total_usd ?? mod.total_cost_usd ?? mod.total_variance_usd ?? mod.total_core_value_usd ?? 0;
      }
    });
  }

  return (
    <div className="min-h-screen bg-[#F3F1EC] font-sans text-stone-800">
      <Header
        totalIssues={totalIssues}
        totalDollars={totalDollarsRaw}
        lastRefresh={lastRefresh}
        onRefresh={refresh}
      />
      <main className="max-w-[1200px] mx-auto px-6 py-6">
        <Outlet context={{ dashboard: data, dashboardLoading: loading, refreshDashboard: refresh }} />
      </main>
    </div>
  );
}
